import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import {
  callSelectors,
  currentUserSelectors,
  environmentSelectors,
  servicesSelectors
} from '@lifesize/nucleus';
import { showOnboarding } from 'actions/Onboarding';
import { addNotification } from 'actions/Notification';
import { FIRST_TIME_USER_SETTING } from 'constants/UserSettings';
import CoreLayout from 'layouts/CoreLayout/CoreLayout';
import { popoutPresentationSelector } from 'selectors/call';
import { isStartingCall } from 'utils/call-utils';

const mapStateToProps = (state) => {
  const firstTimeUser = _get(currentUserSelectors.myInfo(state), ['userSettings', FIRST_TIME_USER_SETTING]);
  const isDesktop = environmentSelectors.platform(state).isDesktop;
  const activeCall = callSelectors.activeCallSelector(state);
  const isLoggedIn = servicesSelectors.selectConnected(state);
  const onboardingAvailable = !_get(state, 'app.onboarding.disableOnboarding') && !isDesktop;
  const showPermissionPage = _get(state, 'app.onboarding.showPermissions');

  // This could probably end up being cleaned up somewhere since we display the
  // FSM in another way as well. If we have an active call that is not connected,
  // change the style in addition to whenever there is FSM subcomponent present.
  return ({
    firstTimeUser,
    ie11Enabled: true, // Hard code IE11 enabled (see WEBTOP-1500)
    isDesktop,
    isFullScreenModalVisible: isStartingCall(activeCall) || !!_get(state, 'app.modal.visibleComponent'),
    isLoggedIn,
    isPopoutOpen: popoutPresentationSelector(state), // IMPORTANT: for the guest join flow, CoreLayout is not used
    onboardingAvailable,
    partialModal: _get(state, 'app.modal.partialModal'),
    showPermissionPage
  });
};

function mapDispatchToProps(dispatch) {
  return {
    addNotification: (type, props) => {
      dispatch(addNotification(type, props));
    },
    showOnboarding: () => {
      dispatch(showOnboarding());
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoreLayout));
